<div class="bg-white">
  <app-citizen-header></app-citizen-header>

  <div class="flex">
    <div
      class="{{tabOpen ? 'w-[240px]':'w-[80px]'}}  max-h-full overflow-scroll leftTab transition-all duration-200 ease-linear">
      <div class="flex flex-col gap-1" appSequentialAnimate direction="vertical">
        <div (click)="tabOpen=!tabOpen" class="h-[130px] py-3 w-full flex items-center group justify-center cursor-pointer
             text-secondary-500 font-bold">
          <mat-icon class="scale-150 {{tabOpen ? 'rotate-90':'group-hover:rotate-90'}}  transition-all duration-200 ">
            notes
          </mat-icon>
        </div>

        <div *ngIf="selectedCategory=='sector' ||selectedCategory=='institution' " class="group border border-primary-500 inline-flex rounded-md
       items-center transition-all duration-300 bg-white/5 px-2 mr-2 py-1 focus-within:border-primary-500">
          <input
            class="outline-none !bg-transparent px-2 py-2 text-white"
            id="search"
            placeholder="{{'Tafuta'|concat|translate}}"
            type="text"
            (input)="searchData($event.target.value)"
          />
          <mat-icon
            class="text-secondary-500 text-sm"
            svgIcon="search"
          ></mat-icon>
        </div>

        @if (selectedCategory == 'Special_Needs') {
          @for (group of specialNeedsOptions; track group) {
            <div [ngClass]="{'border-l-[5px] border-secondary-500':group?.value==activeTab}"
                 (click)="onTabSelect(group?.value)" (keyup)="$event.stopPropagation()"
                 class=" py-3 px-2 w-full flex items-center gap-2 {{tabOpen ?'justify-start':'justify-center'}} cursor-pointer
             text-white font-bold bg-gradient-to-r from-white/30 to-transparent">
              <mat-icon [svgIcon]="group?.name|concat"></mat-icon>
              <span *ngIf="tabOpen">{{ group?.name |concat|translate }}</span>
            </div>
          }
        }

        @if (selectedCategory == 'G2B' || selectedCategory == 'G2F') {
          @for (group of ServiceClusterEnumOptions; track group) {
            <div [ngClass]="{'border-l-[5px] border-secondary-500':group?.name==activeTab}"
                 (click)="onTabSelect(group?.name)"
                 class=" py-3 px-2 w-full flex items-center gap-2 {{tabOpen ?'justify-start':'justify-center'}} cursor-pointer
             text-white font-bold bg-gradient-to-r from-white/30 to-transparent">
              <mat-icon [svgIcon]="selectedCategory=='G2F' ? 'foreigner':'biashara'"></mat-icon>
              <span *ngIf="tabOpen">{{ group?.value| concat|translate }}</span>
            </div>
          }
        }

        @if (selectedCategory == 'sector') {
          <ng-container *ngIf="citizenSectors$ | async as sectors">
            @for (group of sectors; track group) {
              <div [ngClass]="{'border-l-[5px] border-secondary-500':group?.sectorUniqueId==activeTab}"
                   (click)="onTabSelect(group?.sectorUniqueId)"
                   class=" py-3 px-2 w-full flex items-center gap-2 {{tabOpen ?'justify-start':'justify-center'}} cursor-pointer
             text-white font-bold bg-gradient-to-r from-white/30 to-transparent">
                <mat-icon [svgIcon]="group?.sectorIcon+'_white'">
                </mat-icon>
                <span *ngIf="tabOpen">{{ group?.sectorName | titlecase }}</span>
              </div>
            }
          </ng-container>
        }

        @if (selectedCategory == 'institution') {
          <ng-container *ngIf="institutions$ | async as institutions">
            @for (group of institutions; track group) {
              <div [ngClass]="{'border-l-[5px] border-secondary-500':group?.institutionUniqueId==activeTab}"
                   (click)="onTabSelect(group?.institutionUniqueId)"
                   class=" py-3 px-2 w-full flex items-center gap-2 {{tabOpen ?'justify-start':'justify-center'}} cursor-pointer
             text-white font-bold bg-gradient-to-r from-white/30 to-transparent">
                <mat-icon [svgIcon]="'taasisi'">
                </mat-icon>
                <span *ngIf="tabOpen">{{ group?.institutionName | titlecase }}</span>
              </div>
            }
          </ng-container>

        }
      </div>
    </div>
    <div class="flex-grow-1   overflow-scroll  ">
      <div class="w-11/12 mx-auto">
        <app-shared-portal-services-list (searchKeyWord)="onSearch($event)"
                                         (paginate)="paginate($event)"></app-shared-portal-services-list>
      </div>
    </div>
  </div>

  <app-portal-footer></app-portal-footer>

</div>
